var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum } from 'class-validator';
import { Gewinnermittlungsart } from '../../office-location-datev-settings/types/datev-enums.js';
/**
 * Query for `GET /office-locations/:officeLocationId/datev-mode-switch/preview`
 * (PRD #1319 / RS-005).
 *
 * A dry run of the Gewinnermittlungsart switch: it reports what the switch
 * *would* do without touching the ledger. `target` is the Gewinnermittlungsart
 * the caller is considering switching to.
 */
export class PreviewModeSwitchQueryDto {
    target;
}
__decorate([
    IsEnum(Gewinnermittlungsart),
    __metadata("design:type", String)
], PreviewModeSwitchQueryDto.prototype, "target", void 0);
/**
 * Result of a mode-switch preview (PRD #1319 / RS-005).
 *
 * Both counts come from the same `ModeSwitchPlanner` the switch command uses —
 * so the preview and the action agree by construction, not by discipline.
 *
 * `carryOverCount` is how many already-transmitted Belege would be seeded as
 * `MODE_SWITCH_CARRY_OVER` and therefore *not* re-exported. `foldForwardCount`
 * is how many open receivables (never transmitted under the outgoing trigger)
 * would flow past-dated into the next export — the Übergangsgewinn bucket.
 *
 * Nothing is written; the preview is advisory. The switch command recomputes
 * both counts inside its serialized transaction at confirm time and rejects a
 * stale preview rather than executing on numbers that changed since render.
 */
export class DatevModeSwitchPreviewResponseDto {
    target;
    carryOverCount;
    foldForwardCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevModeSwitchPreviewResponseDto.prototype, "target", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevModeSwitchPreviewResponseDto.prototype, "carryOverCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DatevModeSwitchPreviewResponseDto.prototype, "foldForwardCount", void 0);
//# sourceMappingURL=datev-mode-switch-preview.dto.js.map